import "./NotesView.scss";

import React, {FC} from "react";
import {shallowEqual} from "react-redux";
import {dateTimeFromNullableTicks, UtcZone} from "../../util/DateHelper";
import {DateTimeControl} from "../common/DateTimeControl";
import {useAppSelector} from "../../hooks/ReduxHooks";
import {ButtonPanel} from "../common/ButtonPanel";
import {Button} from "@mui/material";
import {StackPanel} from "../panels/StackPanel";
import {NoteEditPageContent} from "./NoteEditPageContent";
import {NoteEditPageButtons} from "./NoteEditPageButtons";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import {popOutContent} from "../common/HideContentButton";

export const NotePageContentView: FC = () => {
    const selectedPage = useAppSelector(({notesState}) => notesState.selectedPage, shallowEqual)!;
    const isMobile = useAppSelector(s => s.system.isMobile);

    console.log("Render Note Page:", selectedPage?.ClientId, selectedPage?.Name);

    const buttons = (
        <StackPanel orientation="horizontal"
                    className="panel">
            <NoteEditPageButtons/>

            {!isMobile && <Button variant="contained" onClick={() => popOutContent()} size="small" title="Expand" color="inherit">
                <AspectRatioIcon/>
            </Button>}
        </StackPanel>
    );

    return (
        <div className="notes-content">
            <ButtonPanel buttons={buttons} fill={true} buttonLocation="bottom">

                <NoteEditPageContent/>

                <div className="last-modified">
                    <DateTimeControl title={isMobile ? "" : "Modified:"}
                                     time={dateTimeFromNullableTicks(selectedPage?.ModifiedTime, UtcZone)}/>
                </div>
            </ButtonPanel>
        </div>
    );
};
